var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"productSlide"},_vm._l((_vm.propDots),function(d){return (_vm.propDots)?_c('div',{staticClass:"productSlideDrag",staticStyle:{"background-color":"#fff"},attrs:{"id":'dot_' + d}}):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }